import React from 'react'

import { ReactComponent as AccountIcon } from './account.svg'
import { ReactComponent as ArrowIcon } from './arrow.svg'
import { ReactComponent as BellIcon } from './bell.svg'
import { ReactComponent as BntIcon } from './bnt.svg'
import { ReactComponent as CenterIcon } from './center.svg'
import { ReactComponent as ClassIcon } from './class.svg'
import { ReactComponent as DataIcon } from './data.svg'
import { ReactComponent as EmailIcon } from './email.svg'
import { ReactComponent as EyeIcon } from './eye-icon-2.svg'
import { ReactComponent as EyeSlashIcon } from './eye-slash.svg'
import { ReactComponent as LectureIcon } from './lecture.svg'
import { ReactComponent as LockOpenIcon } from './lock-open.svg'
import { ReactComponent as MarkIcon } from './mark.svg'
import { ReactComponent as OverviewIcon } from './overview.svg'
import { ReactComponent as PenIcon } from './pen.svg'
import { ReactComponent as QnaIcon } from './qna.svg'
import { ReactComponent as SettingIcon } from './setting.svg'
import { ReactComponent as UserIcon } from './user.svg'
import { ReactComponent as WritingIcon } from './writing.svg'
import { ReactComponent as SearchIcon } from './search.svg'
import { ReactComponent as ChapterIcon } from './chapter.svg'
import { ReactComponent as TrashIcon } from './trash.svg'
import { ReactComponent as InfoIcon } from './info.svg'
import { ReactComponent as SignUpIcon } from './signup-icon.svg'
import { ReactComponent as OrdersIcon } from './orders.svg'
import { ReactComponent as MyPageIcon } from './mypage.svg'

// 아이콘 객체로 관리
export const Icons = {
  info: InfoIcon,
  trash: TrashIcon,
  chapter: ChapterIcon,
  search: SearchIcon,
  account: AccountIcon,
  arrow: ArrowIcon,
  bell: BellIcon,
  bnt: BntIcon,
  center: CenterIcon,
  class: ClassIcon,
  data: DataIcon,
  email: EmailIcon,
  eye: EyeIcon,
  eyeSlash: EyeSlashIcon,
  lecture: LectureIcon,
  lockOpen: LockOpenIcon,
  mark: MarkIcon,
  overview: OverviewIcon,
  pen: PenIcon,
  qna: QnaIcon,
  setting: SettingIcon,
  user: UserIcon,
  writing: WritingIcon,
  signup: SignUpIcon,
  orders: OrdersIcon,
  mypage: MyPageIcon,
}

// 개별 export
export {
  InfoIcon,
  TrashIcon,
  AccountIcon,
  ArrowIcon,
  BellIcon,
  BntIcon,
  CenterIcon,
  ClassIcon,
  DataIcon,
  EmailIcon,
  EyeIcon,
  EyeSlashIcon,
  LectureIcon,
  LockOpenIcon,
  MarkIcon,
  OverviewIcon,
  PenIcon,
  QnaIcon,
  SettingIcon,
  UserIcon,
  WritingIcon,
  SearchIcon,
  ChapterIcon,
  MyPageIcon,
  OrdersIcon,
}

// 타입 정의
export type IconName = keyof typeof Icons

// 편리한 Icon 컴포넌트
interface IconProps {
  name: IconName
  size?: number
  color?: string
  className?: string
  onClick?: () => void
}

export const Icon: React.FC<IconProps> = ({
  name,
  size = 24,
  color = 'currentColor',
  className = '',
  onClick,
}) => {
  return React.createElement(Icons[name], {
    width: size,
    height: size,
    fill: color,
    stroke: color,
    className,
    onClick,
    style: {
      cursor: onClick ? 'pointer' : 'default',
      display: 'block',
    },
  })
}
